/**
 * List front blocks
 */
const BLOCKS = [
	{
		loaded: false,
		test: () => document.querySelector('#block-success'),
		module: () => import(
			/* webpackChunkName: "js/async-block-success" */ './Success'
			)
	},
	{
		loaded: false,
		test: () => document.querySelectorAll('.block-team').length,
		module: () => import(
			/* webpackChunkName: "js/async-block-success" */ './Team'
			)
	},
	{
		loaded: false,
		test: () => document.querySelectorAll('.text-underline').length,
		module: () => import(
			/* webpackChunkName: "js/async-block-underline" */ '../components/tools/Underline'
			)
	},
	{
		loaded: false,
		test: () => document.querySelectorAll('[data-tab-section]').length,
		module: () => import(
			/* webpackChunkName: "js/async-block-Accordeon" */ '../components/tools/Accordeon'
			)
	},
	{
		loaded: false,
		test: () => document.querySelector('#module-map'),
		module: () => import(
			/* webpackChunkName: "js/async-block-map" */ './Map'
			)
	},
	{
		loaded: false,
		test: () => document.querySelector('#menu-primary'),
		module: () => import(
			/* webpackChunkName: "js/async-block-map" */ './Menu'
			)
	},
	{
		loaded: false,
		test: () => document.querySelector('#page-cms-presentation #right-col'),
		module: () => import(
			/* webpackChunkName: "js/async-block-scrollslides" */ './ScrollSlides'
			)
	},
	{
		loaded: false,
		test: () => document.querySelectorAll('[data-animation-number]').length,
		module: () => import(
			/* webpackChunkName: "js/async-block-numbers" */ './Numbers'
			)
	},
	{
		loaded: false,
		test: () => document.querySelector('#fichier-nav > a'),
		module: () => import(
			/* webpackChunkName: "js/async-block-snap" */ './Snap'
			)
	},
	{
		loaded: false,
		test: () => document.querySelector('#panel-hover'),
		module: () => import(
			/* webpackChunkName: "js/async-block-rootservices" */ './RootServices'
			)
	},
	{
		loaded: false,
		test: () => document.querySelectorAll('.item-grid').length,
		module: () => import(
			/* webpackChunkName: "js/async-block-grid" */ './Grid'
			)
	},
	{
		loaded: false,
		test: () => document.querySelectorAll('[data-custom-scroll]').length,
		module: () => import(
			/* webpackChunkName: "js/async-block-Scrollbar" */ './Scrollbar'
			)
	}
]


/**
 * Handle modules async imports
 */
export const initBlocks = () => {
	for (const block of BLOCKS) {
		if (block.test()) {
			if (!block.loaded) {
				block.module().then((module) => {
					module.init()
					block.loaded = true
					block.module = module
				})
			} else {
				block.module.update()
			}
		}
	}
}

/**
 * Update blocks
 */
export const updateBlocks = () => {
	for (const block of BLOCKS) {
		if (block.test()) {
			block.module.update()
		}
	}
}

initBlocks()
